export const keysToRemove = [
  'social_login_proxy_url',
  'notification_proxy_url',
  'login_proxy_url',
  'password_reset_proxy_url',
  'passwordless_registration_proxy_url',
  'registration_proxy_url',
  'refresh_proxy_url'
] as const;
export type RemovableKeys = typeof keysToRemove[number];
